// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__10_fs","detailsBorder":"styles_detailsBorder__2dcnZ"};